<template>
  <div class="order">
      <ul class="nav">
        <li :class="{native:inds==index}" v-for="(item,index) in navList" :key="index" @click="navTab(index)">{{item.txt}}</li>
      </ul>
      <div class="list" v-for="(item,index) in allMsg" :key="index">
          <div class="top">
              <p class="left">{{item.name}}</p>
              <p class="right" v-if="item.status == 'PROCESSING'" style="color:#E24709">协调中</p>
              <p class="right" v-if="item.status == 'CANCEL'" style="color:#9B9B9B">已取消</p>
              <p class="right" v-if="item.status == 'FINISH'" style="color:#4A4A4A">已完成</p>
              <p class="right" v-if="item.status == 'PENDING'" >待处理</p>
          </div>
          <div class="bottoms">
              <p>预约时间：{{item.created_time}}</p>
          </div>
      </div>
      <footer class="footer">
        <ul>
            <router-link to="/index" tag="li" class="tj">
            <img v-if="ind==1" src="../assets/index1.png" alt="">
            <img v-else src="../assets/index2.png" alt="">
            <em>首页</em>
            </router-link>
            <router-link to="/order" tag="li" class="zx">
            <img v-if="ind==2" src="../assets/记录2.png" alt="">
            <img v-else src="../assets/记录1.png" alt="">
            <em class="active">预约记录</em>
            </router-link>
        </ul>
      </footer>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      ind: 0,
      inds: 0, //导航下标
      navList: [
        {
          txt: "全部"
        },
        {
          txt: "协调中"
        },
        {
          txt: "已完成"
        },
        {
          txt: "已取消"
        }
      ],
      allMsg: []
    };
  },
  created() {
    console.log(this.inds);
    axios.get(HPV_URL+"/api/bookings/").then(res => {
      if (this.inds == 0) {
        this.allMsg = res.data.hits;
      }
    });
  },
  methods: {
    navTab(index) {
      this.inds = index;
      this.page = 1;
      console.log(this.inds);

      axios.get(HPV_URL+"/api/bookings/").then(res => {
        if (this.inds == 0) {
          this.allMsg = res.data.hits;
        }else if(this.inds == 1){
          this.allMsg = res.data.hits.filter((item,index) =>{
            return item.status == 'PROCESSING'
          })
        }else if(this.inds == 2){
          this.allMsg = res.data.hits.filter((item,index) =>{
            return item.status == 'FINISH'
          })
        }else if(this.inds == 3){
          this.allMsg = res.data.hits.filter((item,index) =>{
            return item.status == 'CANCEL'
          })
        }
      });
    }
  }
};
</script>

<style scoped>
.order{
  margin-bottom: 100px;
}
.nav {
  width: 100%;
  height: 44px;
  margin-top: 1px;
  background: #fff;
  padding: 0 5.3%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  box-sizing: border-box;
  border-bottom: 1px solid #dfdfdf;
}
.nav li {
  /* width: 14.9%; */
  height: 28px;
  line-height: 28px;
}
.nav .native {
  font-size: 18px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #e24709;
  border-bottom: 2px solid #e24709;
  border-radius: 1px;
}
.list {
  border: 1px solid #eaeaea;
  margin: 15px 20px 0 20px;
  border-radius: 5px;
}
.list .top {
  display: flex;
  justify-content: space-between;
  height: 45px;
  line-height: 45px;
  font-size: 16px;
  margin: 0 15px;
  border-bottom: 1px solid #dfdfdf;
}
.list .bottoms {
  font-size: 14px;
  height: 44px;
  line-height: 44px;
  margin: 0 15px;
}
.footer {
  width: 100%;
  height: 55px;
  position: fixed;
  bottom: 0;
  left: 0;
  background: rgba(255, 255, 255, 1);
  border-top: 1px solid #dfdfdf;
}
.footer ul {
  width: 100%;
  height: 55px;
  display: flex;
}
.footer ul li {
  width: 50%;
  height: 55px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.footer ul li img {
  width: 30px;
  height: 22px;
  margin-top: 8px;
}
.footer ul .xz img {
  width: 17px;
  height: 21px;
}
.footer ul .tj img {
  width: 22px;
  height: 21px;
}
.footer ul .zx img {
  width: 20px;
  height: 21px;
}
.footer ul li em {
  margin-top: 3px;
}
.footer ul li .active {
  color: #e24709;
}
</style>



// WEBPACK FOOTER //
// src/components/order.vue